var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoCombinationMobileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 175,
    viewBox: "0 0 375 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3625 167.835C-77.1715 151.34 -126.553 148.876 -155 176.78L-155 0H531V200C523.966 187.904 495.176 164.536 436.282 167.835C362.665 171.959 358.094 166.595 294.275 162.685C227.104 158.57 162.53 188.454 29.3625 167.835Z",
    fill: "#A2C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCombinationMobileBg);
export default __webpack_public_path__ + "static/media/noCombinationMobileBg.0dd45cbafb2434996923598725a6fbde.svg";
export { ForwardRef as ReactComponent };